import React, { useEffect } from 'react';
import Pusher from 'pusher-js';
import { useSelector } from 'react-redux';

import { CHANNEL_PUSHER, MESSAGE_PUSHER } from '../../constants';

const ThePusher = () => {
     const user = useSelector((state) => state.subscriber.user);

     const handlePusher = () => {
          if (!user?.id) return;

          const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
               cluster: process.env.REACT_APP_PUSHER_CLUSTER,
          });

          const reportingChannel = pusher.subscribe(`${CHANNEL_PUSHER.EXPORT_REPORTING_URL}-${user.id}`);
          // Called when url export reporting success
          reportingChannel.bind(MESSAGE_PUSHER.EXPORT_REPORTING_URL, (urlS3) => {
               // data -> url s3
               window.open(urlS3);
          });

          return () => {
               reportingChannel.unbind();
          };
     };

     useEffect(handlePusher, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

     return <></>;
};

export default ThePusher;
